id: '**TrelloConnectionId**'
providerId: 973b2e28-93a2-487f-9019-7e5ba3b25f22
name: '**TrelloConnectionName**'
description: ''
options:
  - key: BASE_URL
    value: '{{ env.__HSS_TRELLO_BASE_URL }}'
    name: BASE_URL
    description: null
    displayType: TEXT
  - key: CARD_ID
    value: '{{ env.__HSS_TRELLO_CARD_ID }}'
    name: CARD_ID
    description: null
    displayType: TEXT
